define('collections/member/groups',[
    'underscore',
    'backbone',
    'utils',
    // custom
    'services/api',
    // models
    'models/member/group'
], function(
    _, Backbone, U,
    API,
    MGroup
) {

    var CGroups = Backbone.Collection.extend({
        model: MGroup,
        url: function() {
            if (this.tree_only) {
                return API.url('users/me/groups/' + (this.tree ? 'tree_only/' : ''));
            }
            return API.url('users/me/groups/' + (this.tree ? 'tree/' : ''));
        },

        // sorting in alphabetical order by name
        comparator: function(model) {
            return model.get('name');
        },

        initialize: function(models, opt) {
            opt = opt || {};
            this.tree = Boolean(opt.tree);
            this.tree_only = Boolean(opt.tree_only);
            this.root_only = Boolean(opt.root_only);
            this.removeExpired = Boolean(opt.removeExpired);
        },

        parse: function(data, opt) {
            var data_out = [];
            // exclude expired groups
            if (this.removeExpired === true) {
                _.each(data, function(group) {
                    if (group.isActive === true) {
                        data_out.push(group);
                    }
                }, this);
            } else {
                data_out = data;
            }

            // prevent circular dependencies by defining subgroups as collection here.
            if (this.root_only) {
                _.each(data_out, function(group) {
                    group.subgroups = new CGroups();
                }, this);
            } else {
                _.each(data_out, function(group) {
                    group.subgroups = new CGroups(group.subgroups, { parse: true });
                }, this);
            }

            return data_out;
        },

        fetch: function(opt) {
            opt = opt || {};
            if (opt.tree) this.tree = opt.tree;
            return CGroups.__super__.fetch.call(this, opt);
        }
    });

    return CGroups;

});

